module.exports = __webpack_public_path__ + "static/25-54d040836c80a968cb11d8fe9c06143a.jpg";